import PropTypes from 'prop-types'
import styled from 'styled-components'

import { px2rem } from '@utils'
import { updateComponent } from '@utils/catalog'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import tokensRenamed from '@constants/tokensRenamed'
import { Icon } from '@mch-group/uikit-components'

const StyledWrapper = styled.div`
  margin-bottom: ${px2rem(40)};
`

const StyledList = styled.li`
  &&& {
    display: grid;
    grid-auto-flow: column;
    grid-template-rows: repeat(${props => props.rows}, 1fr);
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    grid-gap: ${px2rem(2)};

    > .item {
      padding: 0;
      height: ${px2rem(24)};
      line-height: ${tokensRenamed.lineHeights[6].value};

      &.active {
        display: flex;
        align-items: center;
        font-weight: ${tokens.fontWeights.ivarDisplay3.value};
      }
    }
  }
`

const SectorMediumFilterList = ({ selects: selectsProp, selectsChanged, data, rows = 5, columns = 2, title }) => {
  const toggleShows = (showIds) => {
    const sectorIds = selectsProp ? selectsProp.split(',') : []
    const newSelectedIds = [...sectorIds]

    if (newSelectedIds) {
      showIds.forEach((showId) => {
        const foundIndex = newSelectedIds.findIndex(id => id === showId)

        if (foundIndex === -1) {
          newSelectedIds.push(showId)
        } else {
          newSelectedIds.splice(foundIndex, 1)
        }
      })
    }
    updateComponent(newSelectedIds, data, selectsProp, selectsChanged)
  }

  return data ? (
    <StyledWrapper>
      <h2 className='h5 mb-4'>{title || 'Sector'}</h2>
      <StyledList rows={rows} columns={columns}>
        {data.map(show => (
          <span
            className='item'
            key={show.code}
            active={selectsProp && selectsProp.split(',').includes(show.code)}
            onClick={() => toggleShows([show.code])}
            onKeyUp={() => toggleShows([show.code])}
            role='button'
            tabIndex={0}
          >
            {show.value} {selectsProp && selectsProp.split(',').includes(show.code) && <Icon name='checkmark' />}
          </span>
        ))}
      </StyledList>
    </StyledWrapper>
  ) : null
}

SectorMediumFilterList.propTypes = {
  selects: PropTypes.string,
  selectsChanged: PropTypes.func,
  data: PropTypes.array,
  title: PropTypes.string,
  rows: PropTypes.number,
  columns: PropTypes.number
}

export default SectorMediumFilterList
